import React, { Component } from "react";
import { trans } from "../../../helpers/index";
import ApiManager from "../../../apiManager/index";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import ErrorModal from "../../Fragments/ErrorModal";

class MobileStep2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      code: "",
      buttonDisabled: false,
      smsButtonDisabled: false,
      formResponse: "",
      showErrorModal: false,
    };

    this.timeout = null;
    this.lifeTimeCounter = this.lifeTimeCounter.bind(this);
  }

  componentDidMount() {
    if (this.timeout === null) {
      this.lifeTimeCounter();
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  calcStepWidth() {
    return (
      (100 / this.props.mobileConfig.mobileMaxStep) *
      this.props.mobileConfig.mobileStep
    );
  }

  lifeTimeCounter() {
    let seconds = this.props.mobileConfig.mobileTimeLife;

    seconds--;

    this.props.updateParentState({
      mobileTimeLife: seconds,
    });

    if (seconds > -1) {
      this.timeout = setTimeout(this.lifeTimeCounter, 1000);
    }
  }

  lifeTimeConvert() {
    let seconds = this.props.mobileConfig.mobileTimeLife,
      minutes = Math.floor(seconds / 60);

    if (seconds / 60 < 1) {
      minutes = "00";
    }

    if (minutes < 10 && minutes > 0) {
      minutes = "0" + minutes;
    }

    if (seconds > 60) {
      seconds = seconds - minutes * 60;
    }

    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return minutes + ":" + seconds;
  }

  sendData(event) {
    this.setState({ buttonDisabled: true });

    ApiManager.postRequest(
      {
        code: this.state.code,
        token: this.props.mobileConfig.mobileToken,
        _token: this.props.csrf_token.data,
      },
      "/register/fix/confirm"
    ).then(
      (resolve) => {
        this.setState({
          buttonDisabled: false,
          formResponse: resolve.data,
        });

        if (resolve.data.hasOwnProperty("token")) {
          this.props.updateParentState({
            mobileToken: resolve.data.token,
            mobileStep: 3,
          });
        }
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
    event.preventDefault();
  }

  reSendSms() {
    this.setState({ smsButtonDisabled: true });

    ApiManager.postRequest(
      {
        msisdn: this.props.mobileConfig.mobileMsisdn,
        _token: this.props.csrf_token.data,
      },
      "/register/" +
        (this.props.mobileConfig.mobileTab === "mobile" ? "mob" : "fix") +
        "/request"
    ).then(
      (resolve) => {
        this.setState({
          smsButtonDisabled: false,
          formResponse: resolve.data,
        });

        if (resolve.data.hasOwnProperty("token")) {
          this.props.updateParentState({
            mobileStep: 2,
            mobileTimeLife: this.props.config.data.fix_code_lifetime * 60,
            mobileToken: resolve.data.token,
          });
          this.timeout = null;
          this.lifeTimeCounter();
        }
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
  }

  bottomActionPart() {
    if (this.props.mobileConfig.mobileTimeLife > -1) {
      return (
        <>
          <div className="form__form-box form__form-box--with-space form-box">
            <div className="form__time fs41 tc">{this.lifeTimeConvert()}</div>
          </div>
          <div className="form__desc-txt fs13">
            {trans(this.props.trans, "auth.register.tel.call.description")}
          </div>
        </>
      );
    }

    return (
      <button
        className={`form__btn btn--with-space btn btn--white fs17${
          this.state.smsButtonDisabled ? " btn--loading" : ""
        }`}
        type="button"
        disabled={this.state.smsButtonDisabled}
        onClick={() => this.reSendSms()}
      >
        {trans(this.props.trans, "auth.register.tel.call.button.title")}
      </button>
    );
  }

  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  render() {
    let errorMsisdnClass = "",
      errorMsisdnBox = "",
      errorCodeClass = "",
      errorCodeBox = "",
      errorBox = "";

    if (this.state.formResponse !== "") {
      if (this.state.formResponse.status === "INVALID_DATA") {
        if (this.state.formResponse.errors.hasOwnProperty("msisdn")) {
          errorMsisdnClass = " form-error";
          errorMsisdnBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.msisdn}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("code")) {
          errorCodeClass = " form-error";
          errorCodeBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.code}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("token")) {
          errorBox = (
            <FormMiddlewareError
              message={this.state.formResponse.errors.token}
            />
          );
        }
      }

      if (this.state.formResponse.status === "ERROR") {
        errorBox = (
          <FormMiddlewareError
            message={this.state.formResponse.message}
            trans={this.props.trans}
          />
        );
      }
    }

    return (
      <div className="form">
        <form
          action="#"
          method="post"
          onSubmit={(event) => this.sendData(event)}
        >
          <div className="form__form-box">
            <div className="form__sub-title db fs11">
              {this.props.mobileConfig.mobileStep}{" "}
              {trans(this.props.trans, "auth.register.step.title")}{" "}
              {this.props.mobileConfig.mobileMaxStep}
              {trans(
                this.props.trans,
                "auth.register.step" + this.props.mobileConfig.mobileMaxStep
              )}
            </div>
            <div className="form__step-out">
              <div
                className="form__step"
                style={{ width: this.calcStepWidth() + "%" }}
              ></div>
            </div>
          </div>
          <div className={`form__form-box${errorMsisdnClass}`}>
            <label className="form__label db fs11" htmlFor="tel-number">
              {trans(this.props.trans, "auth.register.tel.title2")}
            </label>
            <div className="form__field-out form__field-out--with-prefix pr">
              <input
                className="form__field fs13 disabled"
                disabled="disabled"
                id="tel-number"
                type="text"
                value={this.props.mobileConfig.mobileMsisdn}
              />
            </div>
            {errorMsisdnBox}
          </div>
          <div
            className={`form__form-box form__form-box--with-space${errorCodeClass}`}
          >
            <label className="form__label db fs11" htmlFor="code">
              {trans(this.props.trans, "auth.register.tel.call.title")}
            </label>
            <div className="form__field-out pr">
              <input
                className="form__field fs13"
                id="code"
                type="text"
                name="code"
                value={this.state.code}
                onChange={(event) => {
                  this.setState({
                    code: event.target.value.trim().replace(/[^\d]/g, ""),
                  });
                }}
              />
            </div>
            {errorCodeBox}
          </div>

          {this.bottomActionPart()}

          {errorBox}

          <button
            className={`form__submit-btn btn btn--yellow fs17${
              this.state.buttonDisabled ? " btn--loading" : ""
            }`}
            type="submit"
            disabled={this.state.buttonDisabled}
          >
            {trans(this.props.trans, "auth.register.tel.button.title2")}
          </button>
        </form>
        {this.errorModal()}
      </div>
    );
  }
}

export default MobileStep2;
